import React, { useState } from "react";
import MessageForm from "@/components/MessageForm";
import ResponseViewer from "@/components/ResponseViewer";
import { toast } from "sonner";
import type {
  LoadingState,
  SendableSubmission,
  SendSubmissionResponse,
} from "@/types/fitconnect";
import { sendMessage } from "@/lib/fitconnect";

const GenericSender = () => {
  const [loadingState, setLoadingState] = useState<LoadingState>("initial");
  const [responseData, setResponseData] =
    useState<SendSubmissionResponse | null>(null);

  const handleSendMessage = async (message: SendableSubmission) => {
    try {
      setLoadingState("pending");
      setResponseData(null);

      const response = await sendMessage(message);

      setResponseData(response);
      setLoadingState(response.success ? "success" : "error");

      if (response.success === true) {
        toast.success("Message sent", {
          description: `Submission sent successfully with ID: ${response.submissionId}`,
        });
      } else {
        toast.error("Failed to send message", {
          description: response.error || "Unknown error occurred",
        });
      }
    } catch (error) {
      const msg =
        error instanceof Error ? error.message : "Failed to send message";
      setLoadingState("error");
      setResponseData({
        success: false,
        error: msg,
        timestamp: new Date().toISOString(),
      });
      toast.error("Error", { description: msg });
    }
  };

  return (
    <main className="container">
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-1">Generischer Sender</h1>
        <p className="text-base-content/70">
          Nachrichten frei konfigurieren und versenden
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <MessageForm
          onSendMessage={handleSendMessage}
          isLoading={loadingState === "pending"}
        />
        <div className="flex flex-col flex-1">
          <ResponseViewer response={responseData} status={loadingState} />
        </div>
      </div>
    </main>
  );
};

export default GenericSender;
